export default __webpack_public_path__ + "static/media/office5.f4eeca4b.jpg";